import angular from 'angular';

import Confirmation from './confirmation.modal.component';
import DateRange from './dateRange.modal.component';
import Quickfind from './quickfind.modal.component';

import Service from './modalService';

import './dateRange.modal.component.scss';
import './quickfind.modal.component.scss';


const Modals = angular
  .module('petroCloud.base.modals', [])
  .component(Confirmation.name, Confirmation)
  .component(DateRange.name, DateRange)
  .component(Quickfind.name, Quickfind)
  .service('ModalService', Service)
  .name;

/* @ngInject */
function runBlock($transitions, $uibModalStack) {
  // Workaround for uib-modal's missing router integration; close modals when browser navigates
  $transitions.onStart({}, () => { $uibModalStack.dismissAll('closed') });
}

angular.module('petroCloud.base.modals').run(runBlock);

export default Modals;
